import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetMaterialAccessLogDetailById } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { errorMsg } from '../../../../Apis/functions';
import { permissionObj } from '../../../../Helpers/permission';

/**
 * @component MaterialDetailsModalApp
 * @description Loads the detail of the material entry selected in the table.
 *
 * The whole header of the modal is read from here, the row is only the id that is asked for. The detail
 * also adds the employee that brought the material in, with their selfie and contact data, the contractor
 * and the guard.
 *
 * The endpoint answers with the entry the material came in with, so the material that was opened is the
 * only one of its materials.
 *
 * @param {Object} itemSelected - Row selected in the table, its id is the material access log id.
 * @returns {Object} The loaded detail, the material it belongs to and whether the exit can be registered from here.
 */
const MaterialDetailsModalApp = ({ itemSelected }) => {
    const dispatch = useDispatch();
    const [detail, setDetail] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Same write as the one of the table, the detail itself is read only
    const canCheckOut = DEV || permission?.includes(permissionObj?.WEB_UNREGISTERED_EXITS_UPDATE);

    useEffect(() => {
        if (itemSelected?.id) {
            getDetail();
        }
    }, [itemSelected?.id]);

    const getDetail = () => {
        dispatch(GetMaterialAccessLogDetailById(itemSelected?.id)).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success) {
                    setDetail(data);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    return {
        detail,
        material: detail?.materials?.[0],
        canCheckOut,
    };
};

export default MaterialDetailsModalApp;
